var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 15,
    viewBox: "0 0 230 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4837 4.76886C21.6899 5.00044 12.2625 4.54081 3.47912 5.5924C-0.603726 6.08121 11.6696 6.34004 15.7729 6.6047C50.3091 8.83228 85.1761 8.78316 119.768 8.74565C151.392 8.71135 183.372 7.4939 214.861 4.39538C215.789 4.30406 232.983 1.86293 226.942 2.77374C225.565 2.98136 223.855 5.38854 222.126 5.93151C209.65 9.84722 195.851 9.491 182.953 9.64047C146.08 10.0678 109.229 8.50605 72.3659 9.97842C57.1028 10.5881 41.8715 11.5804 26.6224 12.4375C22.6581 12.6603 18.5642 13.6933 14.7141 12.7218C13.3427 12.3758 17.5648 12.0189 18.6318 11.089",
    stroke: "#41A58D",
    strokeWidth: 3.33787,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.693e76e4bf8f2a2d44353fc75f7e568b.svg";
export { ForwardRef as ReactComponent };